<template>
  <div>
    <div class="weui-cells__title">修改网点</div>
    <div class="weui-cells weui-cells_radio">
      <label class="weui-cell weui-check__label" :for="item._id" v-for="item in worksites" :key="item._id">
        <div class="weui-cell__bd">
          <p>{{item.fullName}} - {{item.schoolCampus}}</p>
        </div>
        <div class="weui-cell__ft">
          <input type="radio" class="weui-check" name="radio" :id="item._id" :ref="item._id" @click="choose(item._id)" />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
    </div>

    <div class="warehousing-footer-item sureinwarehousing" style="flex:2" @click="save">
      <a href="javascript:;">提 交</a>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      userInfo: {},
      lon: "0",
      lat: "0",
      worksites: [],
      currWorksiteId: "",
      isLoading: true
    };
  },
  created() {
    let loading = weui.loading("数据努力加载中");
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["getLocation"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    wx.ready(function() {
      setTimeout(function() {
        wx.getLocation({
          type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function(res) {
            that.lat = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            that.lon = res.longitude; // 经度，浮点数，范围为180 ~ -180。

            // 根据token查找微信用户信息
            axios
              .get("/api/user/wxuserInfo")
              .then(response => {
                that.userInfo = response.data.data;
                that.currWorksiteId = that.userInfo.worksite._id;

                let params = {
                  lon: that.lon,
                  lat: that.lat
                };
                // 根据地理位置查找网点列表
                axios
                  .get("/api/worksite/listByLoc", { params })
                  .then(res => {
                    loading.hide();
                    that.worksites = res.data.data;
                  })
                  .catch(err => {
                    console.log(err);
                  });
              })
              .catch(error => {
                console.log(error);
                weui.topTips("获取用户信息失败", 2000);
              });
          }
        });
      }, 200);
    });

    wx.error(function(res) {
      weui.topTips("获取地理位置出错", 1000);
      loading.hide();
      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function(res) {
          that.lat = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          that.lon = res.longitude; // 经度，浮点数，范围为180 ~ -180。

          // 根据token查找微信用户信息
          axios
            .get("/api/user/wxuserInfo")
            .then(response => {
              that.userInfo = response.data.data;
              that.currWorksiteId = that.userInfo.worksite._id;

              let params = {
                lon: that.lon,
                lat: that.lat
              };
              // 根据地理位置查找网点列表
              axios
                .get("/api/worksite/listByLoc", { params })
                .then(res => {
                  loading.hide();
                  that.worksites = res.data.data;
                })
                .catch(err => {
                  console.log(err);
                });
            })
            .catch(error => {
              console.log(error);
              weui.topTips("获取用户信息失败", 2000);
            });
        }
      });
    });
  },
  methods: {
    choose(n) {
      this.currWorksiteId = n;
    },
    save() {
      let that = this;
      axios
        .put("/api/user/updateWorksite", { worksite: this.currWorksiteId })
        .then(res => {
          if (res.data.success) {
            weui.toast("保存成功", 1000);
            // 跳转回个人中心页面
            that.$router.push("/userInfo/express/" + that.encodeToken);
          } else {
            weui.alert(res.data.message);
          }
        })
        .catch(err => {
          weui.alert("保存失败");
        });
    }
  },
  watch: {
    worksites: function() {
      this.$nextTick(function() {
        /*现在数据已经渲染完毕*/
        this.$refs[this.currWorksiteId][0].checked = true;
      });
    }
  }
};
</script>

<style scoped>
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/userinfos/WorksiteEdit.vue